import { useQuery } from "@tanstack/react-query";
import { ShippingService } from "../services/shippingService";

const useShippingPartners = () => {
 return useQuery({
    queryKey: ["shippingPartners"],
    queryFn: () => ShippingService.list(),
  });
};

export default useShippingPartners;
